import { render } from "./VlogFooter.vue?vue&type=template&id=1e0f5658&scoped=true"
import script from "./VlogFooter.vue?vue&type=script&lang=js"
export * from "./VlogFooter.vue?vue&type=script&lang=js"

import "./VlogFooter.vue?vue&type=style&index=0&id=1e0f5658&scoped=true&lang=css"

import exportComponent from "E:\\workspace\\digital-gate\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e0f5658"]])

export default __exports__